import config from './config.js'

export default {

  viewparams: {start:0,count:20,sort:"module_id"},

  listmodules: function(ctrl,cb_success) {
    var u = config.baseUrl + 'rest/modules/installed?start=' + this.viewparams.start + '&count=' + this.viewparams.count + '&sort=' + encodeURIComponent(this.viewparams.sort);
    config.get(ctrl,u,'Installierte Module auflisten',cb_success);
  },

  preloadmodule: function(ctrl,files,cb_success) {
    var fd = new FormData();
    fd.append('filename',files[0]);
    config.post(ctrl,config.baseUrl + 'rest/modules/install','Modul laden',fd,cb_success);
  },

  runinstall: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/modules/finish','Modul installieren',JSON.stringify(data),cb_success);
  },

  removemodule: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/modules/uninstall?mid=' + encodeURIComponent(id),'Modul entfernen',cb_success);
  },

  listrundata: function(ctrl,start,count,cb) {
    config.get(ctrl,config.baseUrl + 'rest/modules/protocols?start=' + encodeURIComponent(start) + '&count=' + encodeURIComponent(count),'Protokolle abfragen',cb);
  }

}
